// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"18":"5630612b","308":"df2332a3","579":"c1820f32"}[chunkId] + ".css";
};